var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 906,
    viewBox: "0 0 1440 906",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 906,
    rx: 40,
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 41,
    width: 1440,
    height: 870.101,
    rx: 30,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 41L251 41L251 925.69H0L0 41Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_261_1345)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 146.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 146.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 193.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#837CEE"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 193.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#837CEE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 240.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 240.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 287.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 287.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 334.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 334.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 381.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.0627,
    y: 381.757,
    width: 144.27,
    height: 24,
    rx: 6.5743,
    fill: "#444444"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.6005 97.4707L70.8563 76.3073H76.6349L80.6104 88.0861L81.2755 90.2882H81.3642L82.0292 88.1157L85.9308 76.3073H91.5912L83.581 97.4707H78.6005ZM93.5018 103.84C93.5018 103.84 93.4969 103.84 93.487 103.84C93.487 103.84 93.4919 103.84 93.5018 103.84L97.3443 95.5642L97.3591 97.5446L90.8268 82.2041H96.295L99.103 89.7118L99.5612 91.2783H99.6646L100.152 89.697L102.857 82.2041H108.162L99.0882 103.84C99.0981 103.84 99.0981 103.84 99.0882 103.84H93.5018ZM119.768 97.988C118.744 97.988 117.822 97.786 117.005 97.382C116.187 96.9682 115.502 96.4066 114.95 95.6972H113.679L114.862 94.4854V97.4707H109.748V76.3073H115.098V83.6672H115.202C115.714 83.0563 116.374 82.5736 117.182 82.2189C118 81.8642 118.882 81.6868 119.827 81.6868C121.887 81.6868 123.576 82.4208 124.897 83.8889C126.227 85.3569 126.892 87.3176 126.892 89.7709C126.892 92.1848 126.222 94.1602 124.882 95.6972C123.542 97.2244 121.837 97.988 119.768 97.988ZM118.335 93.5543C119.3 93.5543 120.098 93.2094 120.729 92.5198C121.36 91.8202 121.675 90.9236 121.675 89.83C121.675 88.7364 121.355 87.8447 120.714 87.155C120.084 86.4653 119.29 86.1205 118.335 86.1205C117.389 86.1205 116.596 86.4653 115.955 87.155C115.315 87.8349 114.995 88.7265 114.995 89.83C114.995 90.9236 115.31 91.8202 115.941 92.5198C116.581 93.2094 117.379 93.5543 118.335 93.5543ZM136.855 97.988C134.372 97.988 132.333 97.2195 130.737 95.6825C129.141 94.1454 128.343 92.1996 128.343 89.8448C128.343 87.4605 129.141 85.5047 130.737 83.9776C132.333 82.4504 134.372 81.6868 136.855 81.6868C139.348 81.6868 141.392 82.4553 142.989 83.9923C144.585 85.5195 145.383 87.4703 145.383 89.8448C145.383 92.1996 144.585 94.1454 142.989 95.6825C141.402 97.2195 139.358 97.988 136.855 97.988ZM136.87 93.5247C137.826 93.5247 138.619 93.1799 139.249 92.4902C139.89 91.7907 140.21 90.9089 140.21 89.8448C140.21 88.761 139.89 87.8743 139.249 87.1846C138.609 86.4949 137.816 86.1501 136.87 86.1501C135.904 86.1501 135.102 86.4949 134.461 87.1846C133.821 87.8743 133.5 88.761 133.5 89.8448C133.5 90.9089 133.821 91.7907 134.461 92.4902C135.102 93.1799 135.904 93.5247 136.87 93.5247ZM155.077 104.299C153.875 104.299 152.821 104.166 151.914 103.9C151.008 103.634 150.2 103.244 149.491 102.732C148.791 102.22 148.234 101.658 147.821 101.047C147.417 100.436 147.215 100.131 147.215 100.131L151.19 98.1358C151.19 98.1358 151.303 98.3082 151.53 98.653C151.767 99.0077 152.052 99.3181 152.387 99.5841C152.722 99.86 153.102 100.067 153.525 100.205C153.959 100.343 154.432 100.412 154.944 100.412C156.146 100.412 157.057 100.087 157.678 99.4363C158.309 98.786 158.624 97.8993 158.624 96.7761V95.3869H158.52C157.969 96.047 157.289 96.5544 156.481 96.9091C155.683 97.2638 154.791 97.4411 153.806 97.4411C151.757 97.4411 150.082 96.7367 148.781 95.3278C147.49 93.9188 146.845 92.0222 146.845 89.6379C146.845 87.2733 147.525 85.3569 148.885 83.8889C150.254 82.4208 151.988 81.6868 154.087 81.6868C155.033 81.6868 155.9 81.8691 156.688 82.2336C157.476 82.5982 158.121 83.1105 158.624 83.7707H159.895L158.713 84.9973V82.2041H163.826V96.3475C163.826 98.9486 163.048 100.924 161.491 102.274C159.934 103.624 157.796 104.299 155.077 104.299ZM155.343 93.1553C156.309 93.1553 157.097 92.8252 157.708 92.1651C158.328 91.4951 158.639 90.6231 158.639 89.5492C158.639 88.4851 158.328 87.6279 157.708 86.9777C157.097 86.3176 156.309 85.9875 155.343 85.9875C154.387 85.9875 153.594 86.3176 152.964 86.9777C152.343 87.6279 152.033 88.49 152.033 89.564C152.033 90.6576 152.343 91.5296 152.964 92.1799C153.584 92.8301 154.377 93.1553 155.343 93.1553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.512 80.1191V76.3481H180.35V80.1191H164.512ZM170.438 97.948V78.322H174.45V97.948H170.438Z",
    fill: "url(#paint0_linear_261_1345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.432 97.9481L186.698 76.3482H190.53L198.765 97.9481H194.344L189.439 83.9202L188.612 81.2353H188.521L187.694 83.903L182.746 97.9438H178.432V97.9481ZM182.264 93.1644L183.393 90.0571H193.27L194.447 93.1644H182.259H182.264Z",
    fill: "url(#paint1_linear_261_1345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.726 97.9481V76.3482H204.738V94.1771H214V97.9481H200.726Z",
    fill: "url(#paint2_linear_261_1345)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3533 85.6475C39.8178 85.6475 41.0051 84.4602 41.0051 82.9957C41.0051 81.5312 39.8178 80.3439 38.3533 80.3439C36.8888 80.3439 35.7015 81.5312 35.7015 82.9957C35.7015 84.4602 36.8888 85.6475 38.3533 85.6475Z",
    fill: "#8D86FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6153 70.4801H56.3455C56.3455 70.4801 52.5072 70.1676 50.5733 73.1699C49.657 74.5929 45.0882 81.4967 41.8031 86.4498C41.4653 86.9607 41.5497 87.6321 41.9931 88.0543C43.0656 89.0678 43.7159 90.5161 43.661 92.1207C43.5639 94.8695 41.3428 97.1117 38.594 97.2426C35.5411 97.382 33.0202 94.9498 33.0202 91.9264C33.0202 90.4063 33.6578 89.034 34.6797 88.067C35.1146 87.6574 35.1779 86.9903 34.8443 86.4962L32.7542 83.4222C32.049 82.2315 30.9512 81.3109 29.6422 80.876C29.0806 80.6902 28.4345 80.5678 27.7125 80.5678H21.5855C21.5855 80.5678 19.9345 80.42 20.9691 82.1343L30.778 97.5213C31.9772 99.3243 33.8056 102.132 36.4785 103.175C37.6988 103.652 39.3456 103.496 40.5701 102.93C42.863 101.871 44.1508 100.013 45.1009 98.6065L62.3753 71.7764C62.3753 71.7764 63.0721 70.4801 61.6153 70.4801Z",
    fill: "#8D86FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8563 93.4043C28.747 93.7844 26.2515 90.3768 26.2515 90.3768C26.2515 90.3768 30.6725 97.3186 31.5043 98.5685C32.3362 99.8184 34.4052 102.36 36.4785 103.171C37.6988 103.648 39.5103 103.412 40.7348 102.846C43.0276 101.786 44.4675 99.6453 45.1051 98.6065L53.4742 85.5926C53.4742 85.5926 51.2236 85.3393 43.8341 89.7645C37.9859 93.2692 36.6769 93.2017 33.8605 93.4086L33.8563 93.4043Z",
    fill: "#B8B4F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5625,
    y: 831.69,
    width: 219.876,
    height: 55,
    rx: 16,
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5625 859.19C28.5625 850.077 35.9498 842.69 45.0625 842.69V842.69C54.1752 842.69 61.5625 850.077 61.5625 859.19V859.19C61.5625 868.303 54.1752 875.69 45.0625 875.69V875.69C35.9498 875.69 28.5625 868.303 28.5625 859.19V859.19Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1482 865.19L75.7228 853.469H77.9035L80.4689 860.219C80.7254 860.925 80.9499 861.614 81.2064 862.56C81.495 861.534 81.7356 860.813 81.96 860.219L84.4934 853.469H86.6259L82.2647 865.19H80.1482ZM88.7776 855.682C88.1042 855.682 87.575 855.153 87.575 854.495C87.575 853.838 88.1042 853.325 88.7776 853.325C89.4189 853.325 89.9481 853.838 89.9481 854.495C89.9481 855.153 89.4189 855.682 88.7776 855.682ZM87.7995 865.19V857.269H89.7556V865.19H87.7995ZM91.1674 862.785H93.0273C93.0434 863.474 93.5564 863.907 94.4543 863.907C95.3683 863.907 95.8653 863.538 95.8653 862.961C95.8653 862.56 95.6569 862.272 94.9514 862.111L93.5244 861.775C92.0974 861.454 91.4079 860.781 91.4079 859.514C91.4079 857.959 92.7227 857.029 94.5505 857.029C96.3303 857.029 97.5329 858.055 97.5489 859.594H95.689C95.6729 858.921 95.224 858.488 94.4704 858.488C93.7007 858.488 93.2518 858.841 93.2518 859.434C93.2518 859.883 93.6045 860.171 94.278 860.332L95.705 860.668C97.0358 860.973 97.7092 861.582 97.7092 862.801C97.7092 864.404 96.3463 865.398 94.3902 865.398C92.418 865.398 91.1674 864.34 91.1674 862.785ZM101.155 865.19H99.1986V853.261H101.171V858.295C101.668 857.526 102.598 857.029 103.736 857.029C105.692 857.029 106.719 858.263 106.719 860.316V865.19H104.762V860.781C104.762 859.45 104.105 858.808 103.111 858.808C101.876 858.808 101.155 859.674 101.155 860.861V865.19ZM115.303 865.19H113.251V853.469H117.724C120.386 853.469 121.941 854.816 121.941 857.125C121.941 858.696 121.204 859.819 119.825 860.38L122.053 865.19H119.809L117.82 860.813H115.303V865.19ZM115.303 855.297V859.001H117.724C119.023 859.001 119.793 858.311 119.793 857.125C119.793 855.954 119.023 855.297 117.724 855.297H115.303ZM125.747 865.398C124.064 865.398 123.038 864.42 123.038 862.929C123.038 861.47 124.096 860.556 125.972 860.412L128.345 860.235V860.059C128.345 858.985 127.704 858.552 126.709 858.552C125.555 858.552 124.914 859.033 124.914 859.867H123.246C123.246 858.151 124.657 857.029 126.806 857.029C128.938 857.029 130.253 858.183 130.253 860.38V865.19H128.537L128.393 864.019C128.056 864.837 126.982 865.398 125.747 865.398ZM126.389 863.923C127.591 863.923 128.361 863.202 128.361 861.983V861.566L126.709 861.695C125.491 861.807 125.026 862.208 125.026 862.849C125.026 863.571 125.507 863.923 126.389 863.923ZM134.131 865.19H132.175V857.269H133.97L134.131 858.199C134.532 857.542 135.333 857.029 136.472 857.029C137.674 857.029 138.508 857.622 138.925 858.536C139.326 857.622 140.256 857.029 141.458 857.029C143.382 857.029 144.441 858.183 144.441 860.011V865.19H142.5V860.524C142.5 859.386 141.891 858.792 140.961 858.792C140.015 858.792 139.294 859.402 139.294 860.7V865.19H137.338V860.508C137.338 859.402 136.744 858.808 135.814 858.808C134.884 858.808 134.131 859.418 134.131 860.7V865.19ZM149.904 865.398C147.547 865.398 145.896 863.683 145.896 861.23C145.896 858.744 147.515 857.029 149.84 857.029C152.213 857.029 153.72 858.616 153.72 861.085V861.679L147.756 861.695C147.9 863.089 148.638 863.795 149.936 863.795C151.011 863.795 151.716 863.378 151.941 862.625H153.753C153.416 864.356 151.973 865.398 149.904 865.398ZM149.856 858.632C148.702 858.632 147.996 859.257 147.804 860.444H151.78C151.78 859.354 151.027 858.632 149.856 858.632ZM154.677 862.785H156.537C156.553 863.474 157.066 863.907 157.964 863.907C158.878 863.907 159.375 863.538 159.375 862.961C159.375 862.56 159.166 862.272 158.461 862.111L157.034 861.775C155.607 861.454 154.917 860.781 154.917 859.514C154.917 857.959 156.232 857.029 158.06 857.029C159.84 857.029 161.042 858.055 161.058 859.594H159.198C159.182 858.921 158.733 858.488 157.98 858.488C157.21 858.488 156.761 858.841 156.761 859.434C156.761 859.883 157.114 860.171 157.787 860.332L159.214 860.668C160.545 860.973 161.219 861.582 161.219 862.801C161.219 864.404 159.856 865.398 157.9 865.398C155.927 865.398 154.677 864.34 154.677 862.785ZM164.664 865.19H162.708V853.261H164.68V858.295C165.177 857.526 166.107 857.029 167.246 857.029C169.202 857.029 170.228 858.263 170.228 860.316V865.19H168.272V860.781C168.272 859.45 167.614 858.808 166.62 858.808C165.386 858.808 164.664 859.674 164.664 860.861V865.19Z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.8021,
    y: 848.977,
    width: 114.456,
    height: 21.5456,
    rx: 6,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 57,
    width: 190,
    height: 33.1013,
    rx: 9.63413,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1159.5,
    y: 57.0507,
    width: 111.1,
    height: 33,
    rx: 8.8,
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1290.6,
    y: 57.0507,
    width: 125.4,
    height: 33,
    rx: 8.8,
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 124.101,
    width: 1137,
    height: 134,
    rx: 16,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 140.101C278 131.265 285.163 124.101 294 124.101H1399C1407.84 124.101 1415 131.265 1415 140.101V171.101H278V140.101Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 187.101,
    width: 1105,
    height: 47,
    rx: 16,
    fill: "#333333",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.5,
    y: 187.601,
    width: 1104,
    height: 46,
    rx: 15.5,
    stroke: "#333333",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_261_1345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334 187.269H1387C1393.63 187.269 1399 192.642 1399 199.269V221.936C1399 228.563 1393.63 233.936 1387 233.936H1334V187.269Z",
    fill: "#6860EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1277.77,
    y: 181.657,
    width: 21.0131,
    height: 93.6704,
    rx: 10.5066,
    transform: "rotate(-22.3353 1277.77 181.657)",
    fill: "white",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 284.076,
    width: 138.051,
    height: 24.0509,
    rx: 7,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1181,
    y: 276.101,
    width: 183,
    height: 40,
    rx: 20,
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_261_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1185,
    y: 280.101,
    width: 82,
    height: 32,
    rx: 16,
    fill: "#4E4E4E"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1376,
    y: 276.101,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 334.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 541.101C277.5 532.265 284.663 525.101 293.5 525.101H627.5C636.337 525.101 643.5 532.265 643.5 541.101V680.101C643.5 688.938 636.337 696.101 627.5 696.101H293.5C284.663 696.101 277.5 688.938 277.5 680.101V541.101Z",
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.5 350.101C663.5 341.265 670.663 334.101 679.5 334.101H1013.5C1022.34 334.101 1029.5 341.265 1029.5 350.101V489.101C1029.5 497.938 1022.34 505.101 1013.5 505.101H679.5C670.663 505.101 663.5 497.938 663.5 489.101V350.101Z",
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.5,
    y: 334.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.5 541.101C663.5 532.265 670.663 525.101 679.5 525.101H1013.5C1022.34 525.101 1029.5 532.265 1029.5 541.101V680.101C1029.5 688.938 1022.34 696.101 1013.5 696.101H679.5C670.663 696.101 663.5 688.938 663.5 680.101V541.101Z",
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.5,
    y: 525.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.5,
    y: 716.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.5,
    y: 716.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#424244"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1049.5,
    y: 716.101,
    width: 366,
    height: 171,
    rx: 16,
    fill: "#424244"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 27.4363,
    cy: 21.3267,
    r: 8,
    fill: "#EC6765"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.4363,
    cy: 21.3267,
    r: 8,
    fill: "#F2C846"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.4363,
    cy: 21.3267,
    r: 8,
    fill: "#65C266"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_261_1345",
    x: 283,
    y: 176.101,
    width: 1127,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_261_1345"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.440509 0 0 0 0 0.440509 0 0 0 0 0.440509 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_1345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_1345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_261_1345",
    x: 1183,
    y: 279.101,
    width: 86,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_261_1345"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_261_1345",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_1345",
    x1: 172.941,
    y1: 78.2228,
    x2: 172.941,
    y2: 103.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_261_1345",
    x1: 189.254,
    y1: 78.2229,
    x2: 189.254,
    y2: 103.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B4F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_261_1345",
    x1: 207.791,
    y1: 78.2229,
    x2: 207.791,
    y2: 103.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8B4F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 906,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 41,
    width: 1440,
    height: 870.101,
    rx: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219.876,
    height: 733.121,
    fill: "white",
    transform: "translate(15.061 133.163)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 146.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 193.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 240.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 287.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 334.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.0627,
    y: 381.757,
    width: 24,
    height: 24,
    rx: 6.98519,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_261_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 124.101,
    width: 1137,
    height: 134,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_261_1345"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1334 187.269H1387C1393.63 187.269 1399 192.642 1399 199.269V221.936C1399 228.563 1393.63 233.936 1387 233.936H1334V187.269Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/Dark-Mode.56a3d3a4719f8ada2dcc38be6964c112.svg";
export { ForwardRef as ReactComponent };